module.exports = __webpack_public_path__ + "img/5.2aae1271.png";